import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate, useNavigate} from 'react-router-dom';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Quiz1 from './pages/Quiz1';
import Quiz2 from './pages/Quiz2';
import Quiz3 from './pages/Quiz3';
import Quiz4 from './pages/Quiz4';
import Profile from './pages/Profile';
import Statistics from './pages/Statistics';
import ConfirmEmail from './pages/ConfirmEmail';
import { isAuthenticated, logout } from './services/auth';
import Quiz1Edit from "./pages/Quiz1Edit";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({children}) => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (isAuthenticated()) {
      } else {
        navigate('/login');
      }
    })();
  }, []);

  return isAuthenticated() ? <>{children}</> : null;
};

const App: React.FC = () => {


  return (
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route index path="/" element={<Statistics />} />
              <Route path="/quiz1" element={<Quiz1 />} />
              <Route path="/quiz1/:quizId" element={<Quiz1Edit />} />

              <Route path="/quiz2" element={<Quiz2 />} />
              <Route path="/quiz2/:quizId" element={<Quiz1Edit />} />
              <Route path="/quiz3" element={<Quiz3 />} />
              <Route path="/quiz3/:quizId" element={<Quiz1Edit />} />
              <Route path="/quiz4" element={<Quiz4 />} />
              <Route path="/quiz4/:quizId" element={<Quiz1Edit />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/logout" element={<Logout />} />
            </Route>
            <Route path="*" element={<Navigate to={isAuthenticated() ? "/" : "/login"} />} />
          </Routes>
        </Router>
  );
};

const Logout: React.FC = () => {
  logout();
  return <Navigate to="/login" />;
};

export default App;
